import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

// PrimeVue components
import AutoComplete from "primevue/autocomplete";
import Button from "primevue/button";
import Calendar from "primevue/calendar";
import Card from "primevue/card";
import Checkbox from "primevue/checkbox";
import ColorPicker from "primevue/colorpicker";
import Column from "primevue/column";
import PrimeVue from "primevue/config";
import ConfirmationService from "primevue/confirmationservice";
import ConfirmDialog from "primevue/confirmdialog";
import DataTable from "primevue/datatable";
import Dialog from "primevue/dialog";
import Dropdown from "primevue/dropdown";
import InputMask from "primevue/inputmask";
import InputNumber from "primevue/inputnumber";
import InputText from "primevue/inputtext";
import Menubar from "primevue/menubar";
import ProgressSpinner from "primevue/progressspinner";
import SelectButton from "primevue/selectbutton";
import Tag from "primevue/tag";
import Textarea from "primevue/textarea";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import Tooltip from "primevue/tooltip";

// PrimeVue styles
import "primeicons/primeicons.css";
import "primevue/resources/primevue.min.css";
import "primevue/resources/themes/lara-light-blue/theme.css";

const app = createApp(App);
const pinia = createPinia();

// Register custom components
import TimeInput from "./components/TimeInput.vue";
app.component("TimeInput", TimeInput);

// Import ContextMenu
import ContextMenu from "@imengyu/vue3-context-menu";
import "@imengyu/vue3-context-menu/lib/vue3-context-menu.css";
app.use(ContextMenu);

// Use plugins
app.use(router);
app.use(pinia);
app.use(PrimeVue);
app.use(ToastService);
app.use(ConfirmationService);

// Register PrimeVue directives
app.directive("tooltip", Tooltip);

// Register PrimeVue components
app.component("AutoComplete", AutoComplete);
app.component("Button", Button);
app.component("Calendar", Calendar);
app.component("Card", Card);
app.component("Checkbox", Checkbox);
app.component("ColorPicker", ColorPicker);
app.component("Column", Column);
app.component("ConfirmDialog", ConfirmDialog);
app.component("DataTable", DataTable);
app.component("Dialog", Dialog);
app.component("Dropdown", Dropdown);
app.component("InputMask", InputMask);
app.component("InputNumber", InputNumber);
app.component("InputText", InputText);
app.component("Menubar", Menubar);
app.component("ProgressSpinner", ProgressSpinner);
app.component("SelectButton", SelectButton);
app.component("Tag", Tag);
app.component("Textarea", Textarea);
app.component("Toast", Toast);

// Initialize authentication
import { useAuthStore } from "./stores/authStore";

// Mount the app
app.mount("#app");

// Initialize auth - done after mount to avoid hydration issues
const authStore = useAuthStore();
authStore.initializeAuth().catch((error) => {
  console.error("Failed to initialize authentication:", error);
});
